// extracted by mini-css-extract-plugin
export default {"contenButtons":"BtnAndTable_contenButtons__057DM","disabled":"BtnAndTable_disabled__Jn38Y"};